import React from 'react';
import noInternetImage from './noInternet2.jpeg';

const InternetChecker = () => {
  const modalStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    zIndex: 999999999999999,
  };

  const imageStyle = {
    maxWidth: '80%',
    maxHeight: '80%',
    borderRadius: '10px',
  };

  return (
    <div style={modalStyle}>
      <img src={noInternetImage} alt="No Internet" style={imageStyle} />
    </div>
  );
}

export default InternetChecker;
